export default __webpack_public_path__ + "static/media/Frame2.fed5f8d2.png";